export const LOADER_TIMEOUT = 20000;
export const LOADER_DEFAULT_TEXT = 'Please wait...';
